import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import { BOOLEAN_OPTIONS, MessagePropType, Question } from '@ratehub/base-ui';


function QuestionHasConsumedTobacco({
    name,
    value,
    labelMessage,
    tooltipMessage,
}) {
    return (
        <Question
            field={{
                name: name ?? 'hasConsumedTobacco',
                type: 'boolean',
                value,
                options: BOOLEAN_OPTIONS,
            }}
            type="radio"
            labelMessage={labelMessage || (
                <FormattedMessage
                    id="InsLifeWizard.QuestionHasConsumedTobacco"
                    defaultMessage="Have you consumed tobacco products within the last 12 months?"
                />
            )}
            tooltipMessage={tooltipMessage || (
                <FormattedMessage
                    id="InsLifeWizard.QuestionHasConsumedTobacco.tooltip"
                    defaultMessage="If you’re considered a non-smoker, most life insurance companies will offer you favourable rates due to the decreased risk of health-related issues to smoking."
                />
            )}
            shouldDisplayOptionsAsGrid
        />
    );
}

QuestionHasConsumedTobacco.propTypes = {
    name: PropTypes.string,
    value: PropTypes.bool,
    labelMessage: MessagePropType,
    tooltipMessage: MessagePropType,
};

export default observer(QuestionHasConsumedTobacco);
